import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../actions/AppActions';
import { essayAiRequest } from './services';

export function useEssayAi(redacaoId, page, search, runsPage) {
  const { token, user } = useSelector(s => s.AppReducer);
  const dispatch = useDispatch(), cache = useQueryClient();
  const key = ['essay-ai', user?.id, redacaoId];
  const onError = error => { if (error.status === 401) dispatch(logout()); };
  const query = useQuery([...key, page, search, runsPage], () => essayAiRequest(token, redacaoId,
    `?page=${page}&search=${encodeURIComponent(search)}&runs_page=${runsPage}`), {
    enabled: !!token && !!redacaoId, retry: false, keepPreviousData: true, onError,
    refetchInterval: data => (data?.runs?.data?.some(run => !run.finished_at && ['0', '1'].includes(String(run.status))) || data?.texts?.data?.some(row => ['pending', 'running'].includes(row.status))) ? 5000 : false,
  });
  const settings = useMutation(data => essayAiRequest(token, redacaoId, '/configuracao', 'PUT', data), {
    onSuccess: () => cache.invalidateQueries(key), onError,
  });
  const start = useMutation(data => essayAiRequest(token, redacaoId, '/execucoes', 'POST', data), {
    onSuccess: () => cache.invalidateQueries(key), onError,
  });
  const retry = useMutation(runId => essayAiRequest(token, redacaoId, `/execucoes/${runId}/retentar`, 'POST', {}), {
    onSuccess: () => { cache.removeQueries([...key, 'report']); cache.invalidateQueries(key); }, onError,
  });
  return { query, settings, start, retry };
}


export function useEssayAiReport(redacaoId, attempt, includeDetails = true, runId = null) {
  const { token, user } = useSelector(s => s.AppReducer);
  const dispatch = useDispatch();
  return useQuery(['essay-ai', user?.id, redacaoId, 'report', runId || 'all', includeDetails, attempt],
    () => essayAiRequest(token, redacaoId, runId ? `/execucoes/${runId}/planilha` : '/relatorio', 'POST', { retry: attempt > 0, include_details: includeDetails }).then(response => response.report), {
      enabled: !!token && !!redacaoId, retry: false, refetchOnWindowFocus: false,
      refetchInterval: data => data && ['0', '1'].includes(String(data.status)) ? 4000 : false,
      onError: error => { if (error.status === 401) dispatch(logout()); },
    });
}
